const common = {
    install: function (Vue, options) {
        Vue.prototype._regs = {
            'mobile': /^1((3[\d])|(4[4,5,6,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[1-3,5-8])|(9[1,8,9]))\d{8}$/,
            'email': /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        }
    }
}
export default common